/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { TransactionInfo } from '../model/transactionInfo';
import { USSDTransactionLogModel } from '../model/uSSDTransactionLogModel';
import { USSDTransactionResponseDto } from '../model/uSSDTransactionResponseDto';
import { UssdHubBillingLogDtoPaginatedResponse } from '../model/ussdHubBillingLogDtoPaginatedResponse';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class USSDTransactionLogService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param serviceProviderId 
     * @param sessionId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUSSDTransactionLogGetussdetailsGet(serviceProviderId: string, sessionId: string, observe?: 'body', reportProgress?: boolean): Observable<TransactionInfo>;
    public apiUSSDTransactionLogGetussdetailsGet(serviceProviderId: string, sessionId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TransactionInfo>>;
    public apiUSSDTransactionLogGetussdetailsGet(serviceProviderId: string, sessionId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TransactionInfo>>;
    public apiUSSDTransactionLogGetussdetailsGet(serviceProviderId: string, sessionId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceProviderId === null || serviceProviderId === undefined) {
            throw new Error('Required parameter serviceProviderId was null or undefined when calling apiUSSDTransactionLogGetussdetailsGet.');
        }

        if (sessionId === null || sessionId === undefined) {
            throw new Error('Required parameter sessionId was null or undefined when calling apiUSSDTransactionLogGetussdetailsGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = queryParameters.set('sessionId', <any>sessionId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<TransactionInfo>('get',`${this.basePath}/api/USSDTransactionLog/getussdetails`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param serviceProviderId 
     * @param sessionId 
     * @param phoneNumber 
     * @param shortCode 
     * @param search 
     * @param from 
     * @param to 
     * @param draw 
     * @param page 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUSSDTransactionLogGetussdtransactionlogsGet(serviceProviderId: string, sessionId?: string, phoneNumber?: string, shortCode?: string, search?: string, from?: Date, to?: Date, draw?: number, page?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<UssdHubBillingLogDtoPaginatedResponse>;
    public apiUSSDTransactionLogGetussdtransactionlogsGet(serviceProviderId: string, sessionId?: string, phoneNumber?: string, shortCode?: string, search?: string, from?: Date, to?: Date, draw?: number, page?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<UssdHubBillingLogDtoPaginatedResponse>>;
    public apiUSSDTransactionLogGetussdtransactionlogsGet(serviceProviderId: string, sessionId?: string, phoneNumber?: string, shortCode?: string, search?: string, from?: Date, to?: Date, draw?: number, page?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<UssdHubBillingLogDtoPaginatedResponse>>;
    public apiUSSDTransactionLogGetussdtransactionlogsGet(serviceProviderId: string, sessionId?: string, phoneNumber?: string, shortCode?: string, search?: string, from?: Date, to?: Date, draw?: number, page?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (serviceProviderId === null || serviceProviderId === undefined) {
            throw new Error('Required parameter serviceProviderId was null or undefined when calling apiUSSDTransactionLogGetussdtransactionlogsGet.');
        }










        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = queryParameters.set('sessionId', <any>sessionId);
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('search', <any>search);
        }
        if (from !== undefined && from !== null) {
            queryParameters = queryParameters.set('from', <any>from.toISOString());
        }
        if (to !== undefined && to !== null) {
            queryParameters = queryParameters.set('to', <any>to.toISOString());
        }
        if (draw !== undefined && draw !== null) {
            queryParameters = queryParameters.set('draw', <any>draw);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<UssdHubBillingLogDtoPaginatedResponse>('get',`${this.basePath}/api/USSDTransactionLog/getussdtransactionlogs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUSSDTransactionLogPost(body?: USSDTransactionLogModel, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiUSSDTransactionLogPost(body?: USSDTransactionLogModel, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiUSSDTransactionLogPost(body?: USSDTransactionLogModel, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiUSSDTransactionLogPost(body?: USSDTransactionLogModel, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/api/USSDTransactionLog`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param sessionId 
     * @param phoneNumber 
     * @param shortCode 
     * @param serviceProviderId 
     * @param startFrom 
     * @param take 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiUSSDTransactionLogUssdTransactionGroupGet(id?: string, sessionId?: string, phoneNumber?: string, shortCode?: string, serviceProviderId?: string, startFrom?: number, take?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<USSDTransactionResponseDto>>;
    public apiUSSDTransactionLogUssdTransactionGroupGet(id?: string, sessionId?: string, phoneNumber?: string, shortCode?: string, serviceProviderId?: string, startFrom?: number, take?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<USSDTransactionResponseDto>>>;
    public apiUSSDTransactionLogUssdTransactionGroupGet(id?: string, sessionId?: string, phoneNumber?: string, shortCode?: string, serviceProviderId?: string, startFrom?: number, take?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<USSDTransactionResponseDto>>>;
    public apiUSSDTransactionLogUssdTransactionGroupGet(id?: string, sessionId?: string, phoneNumber?: string, shortCode?: string, serviceProviderId?: string, startFrom?: number, take?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('id', <any>id);
        }
        if (sessionId !== undefined && sessionId !== null) {
            queryParameters = queryParameters.set('sessionId', <any>sessionId);
        }
        if (phoneNumber !== undefined && phoneNumber !== null) {
            queryParameters = queryParameters.set('phoneNumber', <any>phoneNumber);
        }
        if (shortCode !== undefined && shortCode !== null) {
            queryParameters = queryParameters.set('shortCode', <any>shortCode);
        }
        if (serviceProviderId !== undefined && serviceProviderId !== null) {
            queryParameters = queryParameters.set('serviceProviderId', <any>serviceProviderId);
        }
        if (startFrom !== undefined && startFrom !== null) {
            queryParameters = queryParameters.set('startFrom', <any>startFrom);
        }
        if (take !== undefined && take !== null) {
            queryParameters = queryParameters.set('take', <any>take);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<USSDTransactionResponseDto>>('get',`${this.basePath}/api/USSDTransactionLog/ussdTransactionGroup`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
